import { useState } from "react";

import { CircleCheck } from "lucide-react";

import { BaseControlButton } from "./base-control-button";
import { MarkMeetingModal } from "@/modals/mark-meeting-modal";

export const MarkMeetingButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <BaseControlButton
        onClick={() => setIsOpen(true)}
        className="bg-[#349538] text-white hover:bg-[#349538]/90"
      >
        <CircleCheck className="relative -top-1 h-4 w-4" />
        <span>Mark meeting</span>
      </BaseControlButton>

      <MarkMeetingModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};
